module.exports = __webpack_public_path__ + "static/img/icon-card-1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon-card-1.png
// module id = 566
// module chunks = 0